import "./selector.style.scss";

const Selector = ({ data, disabled = false, selected = undefined, onSelected = () => {} }) => {
	const handleOnChange = (event) => {
		const { value } = event.target;
		onSelected(value);
	};

	return (
		<div className={`custom-select ${disabled && "disabled"}`}>
			<select onChange={handleOnChange} disabled={disabled} value={selected}>
				{data.map((item) => {
					return (
						<option key={item} value={item}>
							{item}
						</option>
					);
				})}
			</select>
			<span className="focus"></span>
		</div>
	);
};

export default Selector;
